module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><a href="/#person/'+
((__t=( id ))==null?'':__t)+
'" target="_blank">'+
((__t=( name ))==null?'':__t)+
'</a></td>\r\n<td>'+
((__t=( fmCreatedTime ))==null?'':__t)+
'</td>\r\n';
 if (canEdit) { 
__p+='\r\n<td>\r\n    <i class="fa fa-compress clickable merge" aria-hidden="true" id="'+
((__t=( id ))==null?'':__t)+
'"></i>\r\n</td>\r\n';
 } 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/medicals/patient-sources-row.html
// module id = 373
// module chunks = 0